module.exports = __webpack_public_path__ + "img/chevron-double-down.4d4a6e23.svg";